const Opensource = [
  {
    id: 1,
    code: 'VSCODE',
    category: 'VSCode Extension',
    name: 'Console Logs Cleaner',
    link: 'https://marketplace.visualstudio.com/items?itemName=TirthPatel.console-log-vs-code-extension',
    description: 'VSCode extension to remove all console logs from your project',
  },
  {
    id: 2,
    code: 'VSCODE',
    category: 'VSCode Extension',
    name: 'React Barrel Export Generator',
    link: 'https://marketplace.visualstudio.com/items?itemName=TirthPatel.barrel-export',
    description: 'VSCode extension to generate files in barrel structure for React',
  },
  {
    id: 3,
    code: 'VSCODE',
    category: 'VSCode Extension',
    name: 'Code Line Counter',
    link: 'https://marketplace.visualstudio.com/items?itemName=TirthPatel.countlines',
    description: 'VSCode extension to count lines of code in your project',
  },
  {
    id: 4,
    code: 'NPM',
    category: 'NPM Package',
    name: 'Evently React',
    link: 'https://www.npmjs.com/package/evently-react',
    description: 'Event-driven architecture for React powered by hooks, middleware, and context',
  },
  {
    id: 5,
    code: 'NPM',
    category: 'NPM Package',
    name: 'Accessify React RBAC',
    link: 'https://www.npmjs.com/package/accessify-react-rbac',
    description: 'React RBAC library with hooks and configurable permission matrix',
  },
  {
    id: 6,
    code: 'NPM',
    category: 'NPM Package',
    name: 'Dynamic Formly',
    link: 'https://www.npmjs.com/package/@dynamic_formly/react',
    description: 'Composable form builder for React with customizable fields and validation',
  },
]

export { Opensource }
